// Inlined from @krakenjs/belter supportsPopups — removes the 155 KB (3.9%) belter bundle.
// Detects browser environments that cannot reliably open popup windows.
// Mirrors belter@2.5.0 src/device.js logic.
//
// Lives in its own module so tests can vi.mock it the same way they used
// to mock @krakenjs/belter.
const _ua = (): string => window.navigator.userAgent ?? ''

const _isWebView = (ua: string): boolean =>
  /(iPhone|iPod|iPad|Macintosh).*AppleWebKit(?!.*Safari)|.*WKWebView/i.test(ua) || /\bwv\b/.test(ua) || /Android.*Version\/(\d)\.(\d)/i.test(ua)

const _isIosWebview = (ua: string): boolean => {
  if (!/iPhone|iPod|iPad/.test(ua)) return false
  if (/\bGSA\b/.test(ua)) return true // Google Search App on iOS
  return /.+AppleWebKit(?!.*Safari)|.*WKWebView/.test(ua)
}

const _isAndroidWebview = (ua: string): boolean => /Android/.test(ua) && /Version\/[\d.]+/.test(ua) && !/Opera Mini/i.test(ua)

const _isElectron = (): boolean => typeof process !== 'undefined' && Boolean(process.versions?.electron)

const _isMacOsCna = (ua: string): boolean => /Macintosh.*AppleWebKit(?!.*Safari)/i.test(ua)

// Matches belter@2.5.0 isStandAlone exactly — display-mode media query.
const _isStandAlone = (): boolean =>
  (window.navigator as Navigator & { standalone?: boolean }).standalone === true || window.matchMedia('(display-mode: standalone)').matches

export const supportsPopups = (): boolean => {
  const ua = _ua()
  return !(
    _isWebView(ua) ||
    _isIosWebview(ua) ||
    _isAndroidWebview(ua) ||
    /Opera Mini/i.test(ua) ||
    /FxiOS/.test(ua) ||
    /EdgiOS/.test(ua) ||
    /FBAN|FBAV/.test(ua) ||
    /QQBrowser/.test(ua) ||
    _isElectron() ||
    _isMacOsCna(ua) ||
    _isStandAlone()
  )
}
